export default {
  universes: state => state.universes,
  selectedUniverse: state => state.activeUniverse,
};
